import * as Yup from "yup";
import fieldFormModalidade from "./fieldModalidade";

const { id, icone, tipo } = fieldFormModalidade;

const validationModalidade = Yup.object().shape({
  [id.name]: Yup.string().optional(),
  [icone.name]: Yup.string().optional(),
  [tipo.name]: Yup.string().required(tipo.errorMsg),
});

export { validationModalidade };
